import React, { memo, useEffect } from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';

import Popup from 'src/components/helpers/Popup';
import { EmailTemplateSendGridForm } from 'src/components/EmailTemplateSendGridManagement/EmailTemplateSendGridForm';
import {
  uploadEmailTemplateSendGrid,
  handleUpdateForm,
  fetchEmailTemplateSendGridById,
  handleSetDefaultEditTemplate,
} from 'src/actions/emailTemplatesSendGrid';

import { Footer } from './Footer';
import { usePopupContext } from '../../../contexts/PopupContext';

const EditEmailTemplateSendGridPopupComponent = ({
  activities,
  emailTemplate,
  uploadEmailTemplateSendGrid,
  handleUpdateForm,
  popup,
  fetchEmailTemplateSendGridById,
  handleSetDefaultEditTemplate,
}) => {
  const { closePopup, openPopup, onClosePopup } = usePopupContext();

  useEffect(() => {
    const idEmailTemplate = popup.getIn(['props', 'idEmailTemplate']);

    if (idEmailTemplate) {
      fetchEmailTemplateSendGridById(idEmailTemplate);
    }

    onClosePopup(() => {
      const url = new URL(window.location.href);

      url.searchParams.delete('id');
      window.history.pushState({}, '', url);
      handleSetDefaultEditTemplate();
    });
  }, []);

  const activity = emailTemplate.getIn(['activity', 'selected', 'value']);
  const buyerId = emailTemplate.getIn(['buyer', 'buyer', 'selected', 'id']);
  const projectId = emailTemplate.getIn(['buyer', 'project', 'selected', 'id']);
  const templateName = emailTemplate.getIn(['templateName', 'value']);
  const file = emailTemplate.get('file') ? emailTemplate.get('file') : undefined;
  const htmlSource = emailTemplate.get('htmlSource') ? emailTemplate.get('htmlSource') : undefined;
  const subject = emailTemplate.getIn(['subject', 'value']);
  const fromName = emailTemplate.getIn(['fromName', 'value'], '{{MODULE_NAME}}');
  const fromEmail = emailTemplate.getIn(['fromEmail', 'value'], '{{MODULE_EMAIL}}');

  const isLoading = emailTemplate.get('loading');

  const handleSave = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');

    uploadEmailTemplateSendGrid({
      activity,
      buyerId,
      projectId,
      templateName,
      file,
      htmlSource,
      subject,
      fromName,
      fromEmail,
      idEmailTemplate: id,
    });

    closePopup();
  };

  const handleUpdateHtmlSource = data => {
    handleUpdateForm({
      name: 'editTemplate',
      ...data,
    });
  };

  const handleOpenEditor = () => {
    openPopup('TemplateEditorPopup', { htmlSource, onSave: handleUpdateHtmlSource });
    onClosePopup(() => {
      openPopup('EditEmailTemplateSendGridPopup');
    });
  };

  const handleUploadFile = event => {
    handleUpdateForm({
      name: 'editTemplate',
      formName: 'file',
      formData: event.target.files.item(0),
    });
  };

  const isDisabledSave = !(
    activity &&
    buyerId &&
    projectId &&
    templateName &&
    subject &&
    fromName &&
    fromEmail &&
    (file || htmlSource)
  );

  const footer = (
    <Footer
      isDisabled={isLoading}
      isDisabledSave={isDisabledSave}
      onOpenEditor={handleOpenEditor}
      onSave={handleSave}
      onUploadFile={handleUploadFile}
    />
  );

  return (
    <Popup footer={footer} header="Edit a Template" id="editEmailTemplateSendGridPopup" loading={isLoading}>
      <EmailTemplateSendGridForm activities={activities} emailTemplate={emailTemplate} formName="editTemplate" />
    </Popup>
  );
};

const mapStateToProps = state => ({
  emailTemplate: state.emailTemplatesSendGrid.get('editTemplate'),
  activities: state.eventActivities.getIn(['activitiesOnlyValues', 'emailTemplateActivities', 'target'], List()),
});

/** Edit email template send grid popup component. */
export const EditEmailTemplateSendGridPopup = connect(mapStateToProps, {
  uploadEmailTemplateSendGrid,
  handleUpdateForm,
  fetchEmailTemplateSendGridById,
  handleSetDefaultEditTemplate,
})(memo(EditEmailTemplateSendGridPopupComponent));
